import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core'

import type { Profile } from '@app/models/profile'
import { AssetUrlPipe } from '@app/modules/assets/pipes/asset-url.pipe'

@Component({
  selector: 'sb-interaction-activity-alert',
  templateUrl: './interaction-activity-alert.component.html',
  styleUrl: './interaction-activity-alert.component.scss',
  imports: [AssetUrlPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.display-none]': '!isShown()',
  },
})
export class InteractionActivityAlertComponent {
  readonly profile = input.required<Profile>()

  readonly viewedByThemStatus = computed(() => {
    const status = this.profile().last_viewed_by_them

    if (status === undefined || status === 'never') {
      return undefined
    }

    if (status === 'just_now' && this.profile().online_status !== 'online') {
      return 'recently'
    }

    return status
  })

  readonly isShown = computed(() => !!this.profile().favorited_by_them || this.viewedByThemStatus() !== undefined)
}
